import { LegalLayout } from "@/pages/legal/LegalLayout";
import { termsContent } from "@/legal/legalContent";

export default function TermsPage() {
  return <LegalLayout content={termsContent} testId="terms-page" />;
}
